import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

export function saveLocalStorageTranslations(key, values) {
  localStorage.setItem('i18n_resources', JSON.stringify({ [key]: { translation: values } }))
}

const resources = JSON.parse(localStorage.getItem('i18n_resources')) || {}

const language = JSON.parse(localStorage.getItem('language'))?.lang

i18n
  .use(initReactI18next).init({
    fallbackLng: 'en',
    lng: language,
    resources,
    interpolation: {
      escapeValue: false,
    },
    react: {
      wait: true,
      useSuspense: false,
    },
  })

export default i18n
